module.exports = __webpack_public_path__ + "static/media/office-building_1f3e2.b587d585.png";